{
  "familyId": "GET-BREUK-LEZEN",
  "questions": [
    {
      "id": "GET-BREUK-LEZEN-001",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je de breuk $\\frac{3}{5}$?",
      "options": [
        "drie vijfde",
        "vijf derde",
        "drie van vijf",
        "drie komma vijf"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 5,
            "label": "De breuk 3/5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk lezen",
            "content": "Lees eerst het getal boven de streep, dan het getal onder de streep met '-de' of '-ste' erachter. Boven = 'hoeveel', onder = 'welk soort deel'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Lees eerst het getal boven de streep, dan het getal onder de streep met '-de' erachter. Boven is 3 → 'drie'. Onder is 5 → 'vijfde'. Samen: 'drie vijfde'. Het bovenste getal vertelt hoeveel delen, het onderste getal vertelt welk soort deel.",
        "solutionSteps": [
          "Boven de streep is 3 → 'drie'",
          "Onder de streep is 5 → 'vijfde'",
          "Samen: 'drie vijfde'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{5}$ lees je als 'drie vijfde' — 3 delen van 5.",
          "1": "Je dacht waarschijnlijk dat je het onderste getal eerst leest. Maar bij $\\frac{3}{5}$ staat de 3 boven en de 5 onder. Onthoud: lees altijd eerst het getal boven de streep, dan het getal onder de streep met '-de' erachter.",
          "2": "Je dacht waarschijnlijk dat je 'van' gebruikt. Maar de wiskundige manier is 'drie vijfde', niet 'drie van vijf'. Onthoud: 'drie van vijf' klinkt als een score, niet als een breuk.",
          "3": "Je dacht waarschijnlijk dat dit een kommagetal is. Maar $\\frac{3}{5}$ is een breuk ('drie vijfde'), niet het kommagetal 3,5. Onthoud: $\\frac{3}{5}$ = 0,6 als kommagetal."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-002",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'twee zevende'?",
      "options": [
        "$\\frac{2}{7}$",
        "$\\frac{7}{2}$",
        "$\\frac{2}{9}$",
        "$\\frac{1}{7}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 7,
            "label": "Schrijf de breuk: twee zevende"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk schrijven",
            "content": "Het eerste woord is het getal boven de streep. Het tweede woord geeft het getal onder de streep. 'Twee zevende' → getal boven 2, getal onder 7.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Het eerste woord is het getal boven de streep, het tweede woord geeft het getal onder de streep. 'Twee' → getal boven = 2. 'Zevende' → getal onder = 7. Schrijf als $\\frac{2}{7}$.",
        "solutionSteps": [
          "'Twee' → getal boven = 2",
          "'Zevende' → getal onder = 7",
          "Schrijf als $\\frac{2}{7}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Twee zevende' = getal boven 2, getal onder 7 = $\\frac{2}{7}$.",
          "1": "Je dacht waarschijnlijk dat het getal onder de streep bovenaan staat. Maar 'twee zevende' → 2 boven, 7 onder = $\\frac{2}{7}$. Onthoud: bij $\\frac{7}{2}$ zou je 'zeven halve' zeggen.",
          "2": "Je dacht waarschijnlijk dat 'zevende' bij 9 hoort. Maar zevende = 7, negende = 9. Onthoud: luister goed naar het woord — zeven → zevende.",
          "3": "Je dacht waarschijnlijk dat het getal boven de streep 1 is. Maar 'twee zevende' heeft 2 boven, niet 1. Onthoud: 'eén zevende' zou $\\frac{1}{7}$ zijn."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-003",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{1}{2}$?",
      "options": [
        "een half",
        "een tweede",
        "twee eerste",
        "een komma twee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "De breuk 1/2"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijzondere breuknamen",
            "content": "Sommige breuken hebben een speciale naam: ½ = 'een half', ¼ = 'een kwart', ¾ = 'drie kwart'. Deze namen moet je onthouden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "$\\frac{1}{2}$ is een bijzondere breuk met een speciale naam. We zeggen 'een half' (niet 'een tweede'). Andere bijzondere namen: $\\frac{1}{4}$ = 'een kwart', $\\frac{3}{4}$ = 'drie kwart'.",
        "solutionSteps": [
          "$\\frac{1}{2}$ is een bijzondere breuk",
          "De speciale naam is 'een half'",
          "Andere bijzondere namen: ¼ = 'een kwart', ¾ = 'drie kwart'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ lees je als 'een half'. Dit is een bijzondere breuknaam die je moet onthouden.",
          "1": "Je dacht waarschijnlijk dat de gewone regel geldt. Wiskundig klopt 'een tweede', maar in het dagelijks taalgebruik zeggen we 'een half'. Onthoud: net zoals we 'een kwart' zeggen in plaats van 'een vierde'.",
          "2": "Je dacht waarschijnlijk dat je de noemer eerst leest. Maar bij $\\frac{1}{2}$ is 1 de teller en 2 de noemer. Onthoud: 'twee eerste' zou $\\frac{2}{1}$ zijn (= 2 hele).",
          "3": "Je dacht waarschijnlijk dat dit een kommagetal is. Maar $\\frac{1}{2}$ = 'een half' = 0,5. Onthoud: 'een komma twee' zou 1,2 zijn — dat is iets heel anders."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-004",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'vijf achtste'?",
      "options": [
        "$\\frac{5}{8}$",
        "$\\frac{8}{5}$",
        "$\\frac{5}{3}$",
        "$\\frac{58}{1}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "Schrijf de breuk: vijf achtste"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk schrijven",
            "content": "Het eerste woord is het getal boven de streep. Het tweede woord geeft het getal onder de streep. 'Vijf achtste' → getal boven 5, getal onder 8.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Het eerste woord is het getal boven de streep, het tweede woord geeft het getal onder de streep. 'Vijf' → getal boven = 5. 'Achtste' → getal onder = 8. Schrijf als $\\frac{5}{8}$.",
        "solutionSteps": [
          "'Vijf' → getal boven = 5",
          "'Achtste' → getal onder = 8",
          "Schrijf als $\\frac{5}{8}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vijf achtste' = getal boven 5, getal onder 8 = $\\frac{5}{8}$.",
          "1": "Je dacht waarschijnlijk dat het getal onder de streep bovenaan staat. Maar 'vijf achtste' → 5 boven, 8 onder. Onthoud: $\\frac{8}{5}$ zou 'acht vijfde' zijn.",
          "2": "Je dacht waarschijnlijk dat 'achtste' bij 3 hoort. Maar achtste = 8, derde = 3. Onthoud: luister goed — acht → achtste.",
          "3": "Je dacht waarschijnlijk dat de getallen als één getal gelezen worden. Maar 'vijf achtste' is een breuk met een getal boven (5) en een getal onder (8), niet het getal 58."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-005",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{3}{4}$?",
      "options": [
        "drie kwart",
        "drie vierde",
        "vier derde",
        "driekwart procent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "De breuk 3/4"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijzondere breuknamen",
            "content": "Als het getal onder de streep 4 is, zeggen we 'kwart': ¼ = een kwart, ²⁄₄ = twee kwart (= een half), ¾ = drie kwart.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 5,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "$\\frac{3}{4}$ is een bijzondere breuk met een speciale naam. Getal onder de streep 4 → we zeggen 'kwart' (niet 'vierde'). Getal boven de streep 3 → 'drie'. Samen: 'drie kwart'. Onthoud: $\\frac{1}{4}$ = een kwart, $\\frac{2}{4}$ = twee kwart (= een half), $\\frac{3}{4}$ = drie kwart.",
        "solutionSteps": [
          "Getal onder de streep 4 → we zeggen 'kwart'",
          "Getal boven de streep 3 → 'drie'",
          "Samen: 'drie kwart'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ lees je als 'drie kwart'. Dit is de gebruikelijke naam voor breuken met 4 onder de streep.",
          "1": "Je dacht waarschijnlijk dat de gewone regel geldt. 'Drie vierde' is wiskundig correct, maar in het Nederlands zeggen we 'drie kwart'. Onthoud: net zoals we 'een half' zeggen in plaats van 'een tweede'.",
          "2": "Je dacht waarschijnlijk dat je het getal onder de streep eerst leest. Maar bij $\\frac{3}{4}$ is 3 het getal boven en 4 het getal onder. Onthoud: 'vier derde' zou $\\frac{4}{3}$ zijn.",
          "3": "Je dacht waarschijnlijk dat 'kwart' iets met procenten te maken heeft. Maar drie kwart ($\\frac{3}{4}$) = 75%, maar het is geen procent. Onthoud: een breuk en een percentage zijn verschillende manieren om hetzelfde te schrijven."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-006",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "matching",
      "question": "Koppel elke breuk aan de juiste naam.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "$\\frac{1}{4}$", "right": "een kwart" },
          { "left": "$\\frac{2}{3}$", "right": "twee derde" },
          { "left": "$\\frac{1}{2}$", "right": "een half" },
          { "left": "$\\frac{5}{6}$", "right": "vijf zesde" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken en hun namen",
            "content": "Lees de teller (boven) en de noemer (onder) met '-de' of '-ste' erachter. Bijzondere namen: ½ = 'een half', ¼ = 'een kwart'. Gewone namen: ⅔ = 'twee derde', ⅚ = 'vijf zesde'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_naam_koppelen",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "$\\frac{1}{4}$ = 'een kwart' (bijzondere naam). $\\frac{2}{3}$ = 'twee derde' (teller + noemer met -de). $\\frac{1}{2}$ = 'een half' (bijzondere naam). $\\frac{5}{6}$ = 'vijf zesde' (teller + noemer met -de).",
        "solutionSteps": [
          "$\\frac{1}{4}$ → noemer 4 = 'kwart' → 'een kwart'",
          "$\\frac{2}{3}$ → teller 2, noemer 3 = 'derde' → 'twee derde'",
          "$\\frac{1}{2}$ → noemer 2 = 'half' → 'een half'",
          "$\\frac{5}{6}$ → teller 5, noemer 6 = 'zesde' → 'vijf zesde'"
        ]
      }
    },
    {
      "id": "GET-BREUK-LEZEN-007",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "fill_in",
      "question": "Schrijf de breuk 'vier negende'. Typ in de vorm boven/onder (bijvoorbeeld 3/5).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4/9", "⁴⁄₉"],
        "caseSensitive": false,
        "placeholder": "Typ de breuk..."
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 9,
            "label": "Schrijf de breuk: vier negende",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk schrijven",
            "content": "Het eerste woord is het getal boven de streep. Het tweede woord geeft het getal onder de streep. 'Vier negende' → boven = 4, onder = 9. Schrijf als $\\frac{4}{9}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Het eerste woord ('vier') is het getal boven de streep = 4. Het tweede woord ('negende') geeft het getal onder de streep = 9. Samen vormt dit de breuk $\\frac{4}{9}$. Controle: tel het totaal aantal stukken (9) en pak er 4 — dat is precies $\\frac{4}{9}$.",
        "solutionSteps": [
          "'Vier' → getal boven de streep = 4",
          "'Negende' → getal onder de streep = 9",
          "Schrijf de breuk: $\\frac{4}{9}$"
        ]
      }
    }
  ]
}